<template>
  <div class="AdminClientsProductsManagement">
    <div class="AdminUser">
      <AdminUsersHeader hideCreateUserButton />
    </div>
    <AdminClientsProductsManagementConfigSource
      :sourceClientGroupId="sourceClientGroupId"
      :isSetConfigSourceClientGroupId="isSetConfigSourceClientGroupId"
      @update:sourceClientGroupId="updateSourceClientGroupId"
      @update:productDisplaySettingSource="submitProductDisplaySettingSource"
    />
    <!-- <transition name="fade"> -->
    <AdminClientsProductsManagementModule
      :categories="categories"
      :products="selectedProducts"
      :selectedCategoryName="selectedCategoryName"
      :isCategorySelectedView.sync="isCategorySelectedView"
      :sourceClientGroupId="sourceClientGroupId"
      :isSetConfigSourceClientGroupId="isSetConfigSourceClientGroupId"
      @update:indivDisplaySetting="changeIndivDisplaySetting"
      @update:selectCategory="selectCategory"
    />
    <!-- </transition> -->
    <div class="MenuBar flex justify-flex-end align-center">
      <div class="BtnWrapper">
        <el-button
          v-if="!isCategorySelectedView"
          @click="goToSelectCategories()"
        >
          商品カテゴリに戻る
        </el-button>
        <el-button
          type="primary"
          :disabled="isSetConfigSourceClientGroupId"
          @click="updateProductDisplaySetting()"
        >
          保存
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import AdminUsersHeader from "@/views/admin/AdminUsersHeader.module.vue";
import AdminClientsProductsManagementModule from "@/components/AdminClientsProductsManagement.module.vue";
import AdminClientsProductsManagementConfigSource from "@/components/AdminClientsProductsManagementConfigSource.vue";
// Data Handler
import UsecaseFactory from "@/usecases/usecase.factory.js";
import { apiErrorHandler } from "@/services/apiErrorHandler";

const productUsecase = UsecaseFactory.create("product");
const WARNING_MESSAGE = "編集中のものは保存されませんが、よろしいですか？";

export default {
  name: "AdminClientsProductsManagement",
  components: {
    AdminUsersHeader,
    AdminClientsProductsManagementModule,
    AdminClientsProductsManagementConfigSource,
  },
  data () {
    return {
      isLoadingInstance: null,
      isLoading: false,
      clientGroupId: null,
      categories: [],
      selectedCategoryName: "",
      selectedProducts: [],
      updateInput: {
        showCategories: [],
        hideCategories: [],
        showProducts: [],
        hideProducts: [],
      },
      isDataChanged: false,
      isCategorySelectedView: true,
      sourceClientGroupId: "",
      isSetConfigSourceClientGroupId: false,
    };
  },
  watch: {
    isCategorySelectedView: function () {
      // カテゴリ ⇄ 掲載商品 に遷移した際にスクロールポジションをリセット
      window.scrollTo(0, 0);
    },
  },
  beforeRouteLeave (to, form, next) {
    if (this.confirmSave()) {
      next();
    }
  },
  destroyed () {
    window.removeEventListener("beforeunload", this.beforeRouteLeaveHandler);
  },
  async created () {
    window.addEventListener("beforeunload", this.beforeRouteLeaveHandler);
    this.fetchData();
  },
  methods: {
    /**
     * For events when leaving the page (reload)
     * @param {any} e
     */
    beforeRouteLeaveHandler (e) {
      if (this.isDataChanged) {
        e.returnValue = WARNING_MESSAGE;
      }
    },
    /**
     * For events when leaving the page
     * @returns {boolean}
     */
    confirmSave () {
      if (this.isDataChanged) {
        return window.confirm(WARNING_MESSAGE);
      }
      return true;
    },
    /**
     * For category view changeover
     * @returns {any}
     */
    goToSelectCategories () {
      this.isCategorySelectedView = true;
    },
    /**
     * For category and display setting data acquisition
     */
    async fetchData () {
      this.isLoadingInstance = this.$loading();
      try {
        this.clientGroupId = this.$route.params.clientID;
        const options = {
          clientGroupId: this.clientGroupId,
        };
        const requestAll = [
          productUsecase.getCategories(this.clientGroupId),
          productUsecase.getProductDisplaySetting(options),
          productUsecase.getProductDisplaySettingSource(options),
        ];
        const result = await Promise.all(requestAll);
        const categories = result[0];
        const productDisplaySetting = result[1];
        this.categories = this.setIndivDisplaySetting(categories, productDisplaySetting);
        this.updateInput = {
          ...productDisplaySetting,
        };
        const productDisplaySettingSource = result[2];
        this.sourceClientGroupId = productDisplaySettingSource.data.productDisplaySettingSource;
        // this.isSetConfigSourceClientGroupId = (this.sourceClientGroupId !== "" || this.sourceClientGroupId !== null);
        this.isSetConfigSourceClientGroupId = !!this.sourceClientGroupId; // nullが "" の場合は未設定
      } catch (err) {
        apiErrorHandler(this, err);
      } finally {
        this.isLoadingInstance.close();
      }
    },
    /**
     * Show/hide settings are reflected in the category or product array
     * @param {any} arrayItems categories or products array
     * @param {any} displaySettings productDisplaySetting object
     * @returns {array}
     */
    setIndivDisplaySetting (arrayItems, displaySettings) {
      const {
        hideCategories,
        hideProducts,
        showCategories,
        showProducts,
      } = displaySettings;
      const resultItems = [];
      for (const item of arrayItems) {
        // デフォルト値
        item.indivDisplaySetting = "unset";

        if (hideCategories.includes(item.id)) {
          item.indivDisplaySetting = "indivHidden";
        }
        if (showCategories.includes(item.id)) {
          item.indivDisplaySetting = "indivDisplay";
        }
        if (hideProducts.includes(item.id)) {
          item.indivDisplaySetting = "indivHidden";
        }
        if (showProducts.includes(item.id)) {
          item.indivDisplaySetting = "indivDisplay";
        }

        resultItems.push(item);
      };
      return resultItems;
    },
    /**
     * Reflects product information in the selected category
     * @param {any} item categories array
     */
    selectCategory (item) {
      this.isCategorySelectedView = false;
      this.setProducts(item);
    },
    /**
     * Initializes product information and reflects product information in the selected category.
     * @param {any} item categories array
     */
    setProducts (item) {
      this.selectedProducts = [];
      this.selectedCategoryName = item.name;
      this.selectedProducts = this.setIndivDisplaySetting(item.products, this.updateInput);
    },
    /**
     * Reflects category or product data changed from the radio buttons in the display settings in "this.updateInput"
     * @param {any} updateParams Category or product data changed from the radio buttons in the display settings
     */
    changeIndivDisplaySetting (updateParams) {
      this.isDataChanged = true;
      const {
        indivDisplaySetting,
        type,
        id,
      } = updateParams;
      // unset: 全削除だけなので分岐処理はなし
      // indivDisplay: 一度this.updateInputの各オブジェクトから対象のIDを削除してから表示の配列にIDを追加する
      // indivHidden: 一度this.updateInputの各オブジェクトから対象のIDを削除してから非表示の配列にIDを追加する
      this.delUpdateInput(id);
      if (indivDisplaySetting === "indivDisplay") {
        const key = type === "category" ? "showCategories" : "showProducts";
        this.addUpdateInput(id, key);
      } else if (indivDisplaySetting === "indivHidden") {
        const key = type === "category" ? "hideCategories" : "hideProducts";
        this.addUpdateInput(id, key);
      }
    },
    /**
     * Add ID to the key specified in "this.updateInput"
     * @param {any} id category or product id
     * @param {any} key keys of this.updateInput
     */
    addUpdateInput (id, key) {
      this.updateInput[key].push(id);
    },
    /**
     * remove ID from the all keys in "this.updateInput"
     * @param {any} id category or product id
     */
    delUpdateInput (id) {
      Object.keys(this.updateInput).forEach(key => {
        this.updateInput[key] = this.updateInput[key].filter((cid) => {
          return cid !== id;
        });
      });
    },
    /**
     * Requesting display non-display setting information to the API
     */
    async updateProductDisplaySetting () {
      const updateParams = {
        clientGroupId: this.clientGroupId,
        input: {
          ...this.updateInput,
        },
      };
      const loading = this.$loading();
      try {
        const productsInSelectedCategory = await productUsecase.updateProductDisplaySetting(updateParams);

        if (productsInSelectedCategory.errors) {
          throw new Error(productsInSelectedCategory.errors[0].message);
        }
        const message = "保存しました";
        this.$notify({ message });
      } catch (err) {
        console.error(err);
        apiErrorHandler(this, err);
        this.isLoadingInstance.close();
      } finally {
        loading.close();
      }
      this.isDataChanged = false;
    },
    updateSourceClientGroupId (updateSourceClientGroupId) {
      this.sourceClientGroupId = updateSourceClientGroupId;
    },
    async submitProductDisplaySettingSource (updateSourceClientGroupId) {
      // const loading = this.$loading();
      this.isLoadingInstance = this.$loading();
      try {
        const options = {
          clientGroupId: this.clientGroupId,
          sourceClientGroupId: updateSourceClientGroupId,
        };
        await productUsecase.updateProductDisplaySettingSourceUpdate(options);

        // データの更新をする
        this.fetchData();
      } catch (err) {
        console.error(err);
        apiErrorHandler(this, err);
      } finally {
        // loading.close();
        // this.isLoadingInstance.close();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.AdminClientsProductsManagement {
  position: relative;
  padding-bottom: 60px;

  .AdminUser {
    width: 99%;
    margin: 0 auto;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s;
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  .MenuBar {
    position: fixed;
    bottom: 0;
    width: calc(100% - 165px) ;
    height: 60px;
    background-color: $background-blue-light;
    z-index: 1;

    .BtnWrapper {
      padding-right: 25px;
    }
  }
}
</style>
